<template>
  <div class="home">
    <Header @getLogoInfo="getLogoInfo" @changeDrawer="changeDrawer" />
    <Menu ref="menuRef" />
    <!-- <img alt="Vue logo" @click="getProvince" src="../assets/logo.png">
    <img alt="Vue logo" @click="getEducation" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App xiaojj" /> -->

  </div>
</template>

<script>
// @ is an alias to /src
import Header from './Header.vue';
import Menu from './Menu.vue';

export default {
  name: 'Home',
  data() {
    return {
      proList: [],
    };
  },
  components: {
    Header,
    Menu,
  },
  created() {
    // if (!this.$store.state.token) {
    //   this.$router.push({
    //     path: '/login'
    //   });
    // }
    this.setGrade();
    this.setYearTerms()
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.changeDrawer()
  },
  methods: {
    setGrade() {
      let grades = [],
        currentYear = new Date().getFullYear();
      for (let i = 0; i < currentYear - 2020 + 2; i++) {
        grades.push(2020 + i + '级');
      }
      this.$store.commit('setGrades', grades.reverse());
    },
    changeDrawer() {
      this.$refs.menuRef.handleClickBack()
    },
    setYearTerms() {
      let yt = [],
        currentYear = new Date().getFullYear();
      for (let i = 0; i < currentYear - 2020 + 2; i++) {
        yt.push(`${2020 + i}-${2020 + i + 1} 第 1 学期`);
        yt.push(`${2020 + i}-${2020 + i + 1} 第 2 学期`);
      }
      this.$store.commit('setYearTrems', yt.reverse());
    },
    async getStudentApply() {
      let params = {
        page: 1,
        size: 100,
      };
      let result = await this.$api.instance.getStudentApply(params);
      console.log(result);
    },
    async getLogoInfo() {
      let result = await this.$api.instance.getLogoInfo();
      console.log(result);
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  height: 100%;
  width: 100%;
  // background: #acbfa8;
}
</style>
